function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiKeysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42.2,36.74H31.28V29.46H26.4a12.74,12.74,0,1,1,0-10.92H45.84V29.46H42.2ZM34.92,33.1h3.64V25.82H42.2V22.18H23.89L23.47,21a9.1,9.1,0,1,0,0,6.08l.42-1.22h11Zm-20-3.64A5.46,5.46,0,1,1,20.36,24,5.48,5.48,0,0,1,14.9,29.46Zm0-7.28A1.82,1.82,0,1,0,16.72,24,1.83,1.83,0,0,0,14.9,22.18Z",
    style: {
      fill: "#636c75"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKeysIcon);
export default __webpack_public_path__ + "static/media/api_keys_icon.faf17a3c49f23444710dd0a3a1df6044.svg";
export { ForwardRef as ReactComponent };